export default {
  init() {
    // JavaScript to be fired on the documentation
    $('.doc-nav-option').click(function(){
      //alert('clicked');
      var docOption = $(this).data('doc-option');
      var zipURL = $(this).data('zip-url');
      var docList = $('.documents-list');
      var docListSelect = $('.documents-list-' + docOption);
      var zipURLTarget = $('.documents-list-' + docOption + ' .all-files');

      //$('.all-files a').prop("href", "");
      
      zipURLTarget.append('<a href="' + zipURL + '" class="btn btn-secondary" download>DOWNLOAD ALL</a>')

      //zipURLTarget.prop("href", zipURL);

      docList.fadeOut(300, function(){
        
        setTimeout(function(){ 
          docListSelect.fadeIn();  
        }, 350);
      });
      
    });

    $(".documents-list-nav li a").click(function(e) {
      e.preventDefault();
      var aid = $(this).attr("href");
      $('html,body').animate({scrollTop: $(aid).offset().top - 90},'slow');
    });


    $(".doc-nav-option").click(function(e) {
      e.preventDefault();
      var aid = $(this).attr("data-doc-option");
      setTimeout(function() { 
        $('html,body').animate({scrollTop: $(".documents-list-" + aid).offset().top - 120},'slow');
    }, 370);
      
    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/documentation.js